import type { TFunction } from "i18next";
import { formatDateTime } from "../../../lib/datetime/displayDateTime";

import Chip from "@mui/material/Chip";

export const getMailFilterCols = (t: TFunction) => [
  {
    name: t("mailFilters.cols.name"),
    selector: (row: any) => row.name,
    sortable: true,
  },
  {
    name: t("mailFilters.cols.subject"),
    selector: (row: any) => row.subject,
    sortable: false,
  },
  {
    name: t("mailFilters.cols.description"),
    selector: (row: any) => row.description,
    sortable: false,
  },
  {
    name: t("mailFilters.cols.status"),
    selector: (row: any) => (row.status ? "ACTIVE" : "INACTIVE"),
    sortable: true,
    cell: (row: any) => (
      <Chip
        label={row.status ? t("common.active") : t("common.inactive")}
        size="small"
        color={row.status ? "success" : "error"}
      />
    ),
  },
  {
    name: t("mailFilters.cols.createdBy"),
    selector: (row: any) => row.createdBy || "",
    sortable: true,
  },
  {
    name: t("mailFilters.cols.createdDate"),
    selector: (row: any) =>
      row.createdDate ? formatDateTime(row.createdDate) : "",
    sortable: true,
  },
];

const MailFilterModel = {
  get cols() {
    return getMailFilterCols(((key: string) => key) as TFunction);
  },
  createDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.create"),
    cancelButtonText: t("common.cancel"),
    title: t("mailFilters.createTitle"),
    content: t("mailFilters.createContent"),
  }),
  editDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.update"),
    cancelButtonText: t("common.cancel"),
    title: t("mailFilters.editTitle"),
    content: t("mailFilters.editContent"),
  }),
  WARNING: { color: "warning", icon: "warning", title: "", content: "", info: "" },
  ERROR: { color: "error", icon: "error", title: "", content: "", info: "" },
  SUCCESS: { color: "success", icon: "success", title: "", content: "", info: "" },
  async message(type: any, title: any, content: any, info: any) {
    return new Promise((resolve) => {
      type.title = title;
      type.content = content;
      type.info = info;
      resolve(type);
    });
  },
};

export default MailFilterModel;
